import * as React from 'react'

const ScaleImage = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    className="scale inactive"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 436 249"
    xmlBase="preserve"
    enableBackground="new 0 0 436 249"
    {...props}
  >
    <g id="Layer_1_00000101101732011519875590000009700789437577254543_">
      <path
        id="Layer_5_1_"
        className="st0"
        d="M298.1105,233.6989h-4.8212c0-41.7837-33.9091-74.0857-75.6927-74.0857
			s-75.6928,32.302-75.6928,74.0857h-4.8212c0-44.355,36.159-78.9069,80.514-78.9069S298.1105,189.3439,298.1105,233.6989
			L298.1105,233.6989z"
      />
      <g id="Layer_4_1_">
        <path
          className="st1"
          d="M163.7599,178.7373L64.604,79.5814c-21.2133,21.2132-36.6411,44.5157-47.8905,72.4786l129.208,52.2296
				C150.0998,194.4865,156.2067,185.8084,163.7599,178.7373z"
        />
        <path
          className="st2"
          d="M145.9215,204.2896L16.7135,152.06c-11.2495,27.9629-15.91,51.5868-15.91,81.6389h138.6897
				C139.8146,223.253,142.0645,213.2892,145.9215,204.2896z"
        />
        <path
          className="st1"
          d="M288.9502,203.4861l129.208-54.9616c-11.7316-27.6415-25.231-47.7298-46.4442-68.9431l-99.638,99.638
				C278.9864,186.1298,284.7719,194.3258,288.9502,203.4861z"
        />
        <path
          className="st2"
          d="M295.6999,233.6989h139.8147c0-30.0521-5.6247-57.5329-17.3563-85.1744l-129.208,54.9616
				C293.1287,212.6463,295.3785,222.9316,295.6999,233.6989L295.6999,233.6989z"
        />
        <path
          className="st3"
          d="M271.9153,179.2194l99.7987-99.7987c-21.2132-21.2133-44.5157-36.6411-72.4786-47.8905l-53.0331,131.1365
				C255.8447,166.5236,264.6835,172.1483,271.9153,179.2194L271.9153,179.2194z"
        />
        <path
          className="st4"
          d="M246.0416,162.5059l52.8725-130.6543c-27.6415-11.2495-50.944-15.7492-80.6747-15.7492v141.1002
				C228.0425,157.3633,237.3635,159.1311,246.0416,162.5059L246.0416,162.5059z"
        />
        <path
          className="st4"
          d="M217.5966,157.2026h0.6428V16.1023c-29.7307,0-56.7294,5.464-84.0495,17.0349l54.9616,129.3687
				C197.9904,159.1311,207.472,157.2026,217.5966,157.2026L217.5966,157.2026z"
        />
        <path
          className="st3"
          d="M188.6694,162.6666L133.7078,33.1372C106.0663,44.8688,85.978,58.3681,64.7647,79.5814l98.9952,98.9952
				C170.9917,171.8269,179.3484,166.3629,188.6694,162.6666z"
        />
      </g>
      <g id="Layer_1_2_">
        <path
          id="Ebene_1_1_"
          className="st0"
          d="M245.5997,162.2813l53.8132-131.478l1.4873,0.6087L247.087,162.89L245.5997,162.2813z"
        />
        <path
          className="st0"
          d="M146.2429,203.4861L17.8384,151.5779c11.0887-27.3201,25.8737-49.9797,46.7656-70.8716l98.6738,98.5131
				c0.3214-0.3214,0.8035-0.6428,1.125-1.1249l-99.156-99.1559l-0.6428-0.6428l-0.6428,0.6428
				c-21.374,21.5347-36.6411,44.6764-48.0512,72.8l-0.3214,0.8035l130.0115,52.3903
				C145.7608,204.4503,146.0822,203.9682,146.2429,203.4861z"
        />
        <path
          className="st0"
          d="M1.6071,232.8954c0.1607-29.0879,4.6605-52.3903,15.5885-79.7104l128.4045,51.7475
				c0.1607-0.4821,0.4821-0.9642,0.6428-1.4464l-130.0115-52.551l-0.3214,0.8035C4.6605,180.023,0,203.6468,0,233.6989h1.6226
				C1.6226,233.2168,1.6071,233.3775,1.6071,232.8954L1.6071,232.8954z M164.7241,177.7731L65.8896,79.0993
				c20.5705-20.4097,40.1767-33.5877,67.0147-44.9978l55.1223,128.7259c0.4821-0.1607,1.1249-0.4821,1.6071-0.6428l-55.283-129.3687
				l-0.3214-0.8035l-0.8035,0.3214c-27.8024,11.7315-47.73,25.2308-68.9432,46.1226l-0.6428,0.6428l99.9594,99.7987
				L164.7241,177.7731z"
        />
        <path
          className="st0"
          d="M217.4359,157.2026h1.6071V15.2988h-0.8035c-30.0521,0-56.8901,5.3033-84.3709,17.0349l0.6428,1.6071
				c27.1594-11.5709,53.5152-16.8742,82.9245-17.0349V157.2026z"
        />
        <path
          className="st0"
          d="M218.2394,15.2988h-0.8035v141.9038h1.6071V16.7452c29.2486,0.1607,52.3903,4.6605,79.5497,15.7492
				l0.6428-1.4464C271.5939,19.9593,248.1308,15.2988,218.2394,15.2988z M271.4332,178.7373l1.1249,1.1249L372.9997,79.5814
				l-0.6428-0.6428c-21.5347-21.374-44.6764-36.6411-72.8-48.0512l-0.6428,1.4464c27.8022,11.0888,50.4618,26.0344,71.6751,47.2477
				L271.4332,178.7373L271.4332,178.7373z"
        />
        <path
          className="st0"
          d="M272.5582,179.8622l99.1559-99.1559c20.5704,20.7311,33.7484,40.3373,45.4799,67.336l-128.5652,54.6403
				c0.3214,0.4821,0.4821,1.1249,0.6428,1.6071l130.0115-55.1223l-0.3214-0.8035c-11.8923-27.9629-25.3916-48.0512-46.6049-69.2645
				l-0.6428-0.6428L271.4332,178.7373L272.5582,179.8622L272.5582,179.8622z"
        />
        <path
          className="st0"
          d="M418.801,148.2031l-0.3214-0.8035l-130.0115,55.283c0.1607,0.4821,0.4821,0.9642,0.6428,1.6071
				l128.4044-54.4795c11.4102,26.838,16.8742,54.1581,17.0349,83.246h0.0163v0.8034h1.4301
				C436.1574,203.8075,430.5327,175.8446,418.801,148.2031z"
        />
      </g>
    </g>
    <g id="Layer_2_00000128452219306858726830000015157193635775810484_"></g>
  </svg>
)
export default ScaleImage
